
    export default {
      path: `/home/runner/work/fase2-website/fase2-website/src/components/pages/datenschutzerklaerung/datenschutzerklaerung-view.kpa`,
      template: `<section aria-labelledby="hero-headline" class="datenschutzerklaerung-view">
        <hero-section
            background-image="/images/hero/rechtliches-hero.png"
            headline="Datenschutzerklärung"
            subheadline="Datenschutzerklärung von FASE2"
            text="<strong>Hier finden sie unsere rechtlichen Angaben.</strong><br>Informationen zum Schutz Ihrer Daten bei der Nutzung unserer Webseite und Services."
            button-text2="Jetzt kostenlos beraten lassen!"
            button-link2="/home#kontakt"
        ></hero-section>

        <tool-bar></tool-bar>

        <div class="wrapper">
            <article aria-labelledby="einleitung">
                <h2 id="einleitung">Einleitung</h2>

                <p>
                    Wir freuen uns über Ihren Besuch auf unserer Webseite 
                    <a href="https://fase2.de" target="_blank" rel="noopener noreferrer">www.fase2.de</a> 
                    und Ihr Interesse an unserem Unternehmen und unseren Angeboten. Für externe Links zu fremden Inhalten übernehmen wir trotz sorgfältiger inhaltlicher Kontrolle 
                    keine Haftung, da wir die Übermittlung dieser Informationen nicht veranlasst, den Adressaten der übermittelten Informationen und 
                    die übermittelten Informationen selbst nicht ausgewählt oder verändert haben.
                </p>

                <p>
                    Der Schutz Ihrer personenbezogenen Daten bei der Erhebung, Verarbeitung und Nutzung anlässlich Ihres Besuchs auf unserer Internetseite ist uns ein wichtiges Anliegen 
                    und erfolgt im Rahmen der gesetzlichen Vorschriften, über die Sie sich z.&nbsp;B. unter 
                    <a href="https://www.bfd.bund.de" target="_blank" rel="noopener noreferrer">www.bfd.bund.de</a> informieren können.
                </p>

                <p>
                    Im Folgenden erläutern wir Ihnen, welche Informationen wir während Ihres Besuchs auf unseren Webseiten erfassen und wie diese genutzt werden:
                </p>
            </article>

            <article aria-labelledby="erhebung-speicherung">
                <h2 id="erhebung-speicherung">
                    1. Erhebung und Speicherung personenbezogener Daten sowie Art und Zweck von deren Verwendung
                </h2>

                <h3 id="besuch-der-webseite">a) Beim Besuch der Webseite</h3>

                <p>
                    Bei jedem Zugriff eines Kunden (oder sonstigen Besuchers) auf unserer Webseite werden durch den auf Ihrem Endgerät 
                    (Computer, Laptop, Tablet, Smartphone etc.) zum Einsatz kommenden Internet-Browser automatisch Informationen an den Server unserer Webseite gesendet. 
                    Diese Informationen werden temporär in einem sog. Logfile (Protokolldatei) gespeichert.
                </p>

                <ul>
                    <li>(pseudonymisierte) IP-Adresse des anfragenden Rechners sowie Geräte-ID oder individuelle Geräte-Kennung und Gerätetyp</li>
                    <li>Name der abgerufenen Datei und übertragene Datenmenge sowie Datum und Uhrzeit des Abrufs</li>
                    <li>Meldung über erfolgreichen Abruf</li>
                    <li>anfragende Domain</li>
                    <li>Beschreibung des Typs des verwendeten Internet-Browsers und ggf. des Betriebssystems Ihres Endgeräts sowie der Name Ihres Access-Providers</li>
                    <li>Ihre Browser-Verlaufsdaten sowie Ihre standardmäßigen Weblog-Informationen</li>
                    <li>
                        Standortdaten, einschließlich Standortdaten von Ihrem Mobilgerät.<br>
                        Bitte beachten Sie, dass Sie bei den meisten Mobilgeräten die Verwendung von Standortservices 
                        im Einstellungsmenü des Mobilgeräts steuern oder deaktivieren können.
                    </li>
                </ul>

                <p>
                    Unser berechtigtes Interesse gem. <strong>Art. 6 Abs. 1 S. 1 lit. f) DSGVO</strong> zur Erhebung der Daten beruht auf den folgenden Zwecken:
                </p>

                <ul>
                    <li>Gewährleistung eines reibungslosen Verbindungsaufbaus und einer komfortablen Nutzung der Webseite</li>
                    <li>Auswertung der Systemsicherheit und -stabilität sowie zu weiteren administrativen Zwecken</li>
                </ul>

                <p>
                    In keinem Fall verwenden wir die erhobenen Daten zu dem Zweck, Rückschlüsse auf Ihre Person zu ziehen.
                </p>

                <h3 id="kontaktformular">b) Bei Nutzung unseres Kontaktformulars</h3>

                <p>
                    Bei Fragen jeglicher Art bieten wir Ihnen die Möglichkeit, mit uns über ein auf der Webseite bereitgestelltes Formular Kontakt aufzunehmen. 
                    Dabei ist unter anderem die Angabe einer gültigen E-Mail-Adresse und Ihres Namens erforderlich, damit wir wissen, von wem die Anfrage stammt 
                    und um diese beantworten zu können. Weitere Angaben können freiwillig getätigt werden.
                </p>

                <p>
                    Die Datenverarbeitung zum Zwecke der Kontaktaufnahme mit uns erfolgt gem. 
                    <strong>Art. 6 Abs. 1 S. 1 lit. a) DSGVO</strong> auf Grundlage Ihrer freiwillig erteilten Einwilligung.
                </p>

                <p>
                    Die für die Benutzung des Kontaktformulars von uns erhobenen personenbezogenen Daten werden nach Erledigung der von Ihnen gestellten Anfrage automatisch gelöscht.
                </p>

                <h3 id="angebot-anfrage">c) Bei Anfrage eines verbindlichen Angebots</h3>

                <p>
                    Auf unserer Webseite können Sie uns entweder über das Kontaktformular oder über die Reiter der einzelnen Leistungen 
                    (z.&nbsp;B. „Grünpflege“, „Graupflege“) eine Anfrage zu einem verbindlichen Angebot zukommen lassen. 
                    Dabei bitten wir Sie um die Angabe folgender personenbezogener Daten:
                </p>

                <ul>
                    <li>Daten, die Sie persönlich identifizieren wie Name, E-Mail-Adresse und Telefonnummer</li>
                    <li>Daten, die Ihr Unternehmen identifizieren, wie Firma und Kommunikationsdaten (E-Mail und Telefonnummer)</li>
                    <li>weitere Angaben können freiwillig getätigt werden</li>
                </ul>

                <p>
                    Die genannten Daten werden zur Anbahnung des Vertragsverhältnisses verarbeitet. Bitte beachten Sie, 
                    dass über unsere Webseite weder Vertragsverhältnisse verbindlich zustande kommen noch Zahlungen abgewickelt werden. 
                    Der Vertragsschluss sowie die Abwicklung erfolgen außerhalb unserer Webseite auf telekommunikativem Weg.
                </p>

                <p>
                    Die Verarbeitung der Daten erfolgt aufgrund von <strong>Art. 6 Abs. 1 lit. b) DSGVO</strong>. 
                    Die Speicherfrist ist auf den Vertragszweck und, sofern vorhanden, gesetzliche und vertragliche Aufbewahrungspflichten beschränkt.
                </p>
            </article>

            <article aria-labelledby="personenbezogene-daten">
                <h2 id="personenbezogene-daten">2. Weitergabe von personenbezogenen Daten</h2>
                <p>
                    Eine Übermittlung Ihrer Daten an Dritte zu anderen als den im Folgenden aufgeführten Zwecken findet nicht statt. Wir geben Ihre Daten nur an Dritte weiter, wenn:
                </p>

                <ul>
                    <li>Sie eine ausdrückliche Einwilligung dazu erteilt haben (<strong>Art. 6 Abs. 1 S. 1 lit. a) DSGVO</strong>)</li>
                    <li>dies für die Abwicklung von Vertragsverhältnissen mit Ihnen erforderlich ist (<strong>Art. 6 Abs. 1 S. 1 lit. b) DSGVO</strong>)</li>
                    <li>eine gesetzliche Verpflichtung zur Weitergabe besteht (<strong>Art. 6 Abs. 1 S. 1 lit. c) DSGVO</strong>)</li>
                    <li>
                        die Weitergabe zur Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen erforderlich ist und kein Grund zur Annahme besteht, 
                        dass Sie ein überwiegendes schutzwürdiges Interesse an der Nichtweitergabe Ihrer Daten haben (<strong>Art. 6 Abs. 1 S. 1 lit. f) DSGVO</strong>).
                    </li>
                </ul>

                <p>
                    In diesen Fällen beschränkt sich der Umfang der übermittelten Daten jedoch nur auf das erforderliche Minimum.
                </p>

                <p>
                    Unsere Datenschutzbestimmungen stehen im Einklang mit den geltenden datenschutzrechtlichen Bestimmungen und die Daten werden nur in der Bundesrepublik Deutschland verarbeitet. 
                    Eine Übermittlung in Drittländer findet nicht statt und ist nicht beabsichtigt.
                </p>
            </article>

            <article aria-labelledby="betroffenenrechte">
                <h2 id="betroffenenrechte">3. Betroffenenrechte</h2>

                <p>
                    Auf Anfrage werden wir Sie gern informieren, ob und welche personenbezogenen Daten zu Ihrer Person gespeichert sind (<strong>Art. 15 DSGVO</strong>), insbesondere über:
                </p>

                <ul>
                    <li>die Verarbeitungszwecke,</li>
                    <li>die Kategorie der personenbezogenen Daten,</li>
                    <li>die Kategorien von Empfängern, gegenüber denen Ihre Daten offengelegt wurden oder werden,</li>
                    <li>die geplante Speicherdauer,</li>
                    <li>das Bestehen eines Rechts auf Berichtigung, Löschung, Einschränkung der Verarbeitung oder Widerspruch,</li>
                    <li>das Bestehen eines Beschwerderechts,</li>
                    <li>die Herkunft Ihrer Daten, sofern diese nicht bei uns erhoben wurden, sowie</li>
                    <li>über das Bestehen einer automatisierten Entscheidungsfindung einschließlich Profiling.</li>
                </ul>

                <p>
                    Ihnen steht zudem das Recht zu, etwaig unrichtig erhobene personenbezogene Daten berichtigen oder unvollständig erhobene Daten vervollständigen zu lassen (<strong>Art. 16 DSGVO</strong>).
                </p>

                <p>
                    Ferner haben Sie das Recht, von uns die Einschränkung der Verarbeitung Ihrer Daten zu verlangen, sofern die gesetzlichen Voraussetzungen hierfür vorliegen (<strong>Art. 18 DSGVO</strong>).
                </p>

                <p>
                    Sie haben das Recht, die Sie betreffenden personenbezogenen Daten in einem strukturierten, gängigen und maschinenlesbaren Format zu erhalten oder die Übermittlung an einen anderen Verantwortlichen zu verlangen (<strong>Art. 20 DSGVO</strong>).
                </p>

                <p>
                    Darüber hinaus steht Ihnen das sogenannte „Recht auf Vergessenwerden“ zu, d.&nbsp;h. Sie können von uns die Löschung Ihrer personenbezogenen Daten verlangen, sofern hierfür die gesetzlichen Voraussetzungen vorliegen (<strong>Art. 17 DSGVO</strong>).
                </p>

                <p>
                    Unabhängig davon werden Ihre personenbezogenen Daten automatisch von uns gelöscht, wenn der Zweck der Datenerhebung weggefallen oder die Datenverarbeitung unrechtmäßig erfolgt ist.
                </p>

                <p>
                    Gemäß <strong>Art. 7 Abs. 3 DSGVO</strong> haben Sie das Recht, Ihre einmal erteilte Einwilligung jederzeit gegenüber uns zu widerrufen. Dies hat zur Folge, dass wir die Datenverarbeitung, die auf dieser Einwilligung beruhte, für die Zukunft nicht mehr fortführen dürfen. Unberührt hiervon bleibt die Rechtmäßigkeit der bis dahin auf Grundlage Ihrer Einwilligung erfolgten Datenverarbeitung.
                </p>

                <p>
                    Sie haben zudem das Recht, jederzeit gegen die Verarbeitung Ihrer personenbezogenen Daten Widerspruch zu erheben, sofern ein Widerspruchsrecht gesetzlich vorgesehen ist. Im Falle eines wirksamen Widerrufs werden Ihre personenbezogenen Daten ebenfalls automatisch durch uns gelöscht (<strong>Art. 21 DSGVO</strong>).
                </p>

                <p>
                    Möchten Sie von Ihrem Widerspruchs- oder Widerrufsrecht Gebrauch machen, genügt eine E-Mail an: <a href="mailto:hallo@fase2.de">hallo@fase2.de</a>.
                </p>

                <p>
                    Bei Verstößen gegen die datenschutzrechtlichen Vorschriften haben Sie gem. <strong>Art. 77 DSGVO</strong> die Möglichkeit, Beschwerde bei der zuständigen Aufsichtsbehörde zu erheben. Zuständige Aufsichtsbehörde ist sowohl 
                    <a href="https://www.ldi.nrw.de/" target="_blank" rel="noopener noreferrer">die oder der Landesbeauftragte für Datenschutz und Informationsfreiheit Nordrhein-Westfalen</a> 
                    als auch jede andere Aufsichtsbehörde im Bundesgebiet.
                </p>
            </article>

            <article aria-labelledby="dauer-der-datenspeicherung">
                <h2 id="dauer-der-datenspeicherung">4. Dauer der Datenspeicherung</h2>

                <p>
                    Die erhobenen Daten werden solange bei uns gespeichert, wie dies für die Durchführung der mit uns eingegangen Verträge erforderlich ist oder 
                    Sie Ihr Recht auf Löschung oder Ihr Recht auf Datenübertragung auf ein anderes Unternehmen nicht ausgeübt haben.
                </p>
            </article>

            <article aria-labelledby="cookies">
                <h2 id="cookies">5. Cookies</h2>

                <p>
                    Wir setzen auf unserer Webseite Cookies ein. Hierbei handelt es sich um kleine Text-Dateien, die Ihr Browser automatisch erstellt und 
                    die auf Ihrem Endgerät gespeichert werden, wenn Sie unsere Webseite besuchen.
                </p>

                <p>
                    In dem Cookie werden Informationen abgelegt, die sich jeweils im Zusammenhang mit dem spezifisch eingesetzten Endgerät ergeben. 
                    Dies bedeutet jedoch nicht, dass wir unmittelbar Kenntnis von Ihrer Identität erhalten.
                </p>

                <p>
                    Der Einsatz von Cookies dient zunächst dazu, die Nutzung unseres Angebots für Sie angenehmer zu gestalten: 
                    So setzen wir sog. Session-Cookies ein, um zu erkennen, dass Sie einzelne Unterseiten unserer Webseite bereits besucht haben. 
                    So wird, sofern Sie sich registriert haben, Ihr Kennwort während der Dauer Ihres Besuchs auf unserer Webseite und des Wechselns von 
                    Unterseiten gespeichert, sodass Sie es nicht jedes Mal neu eingeben müssen oder von Ihnen im Warenkorb abgelegte Waren werden gespeichert, 
                    bis Sie „zur Kasse gehen“. Diese Session-Cookies werden nach Verlassen unserer Webseite automatisch gelöscht.
                </p>

                <p>
                    Darüber hinaus setzen wir ebenfalls zur Optimierung der Benutzerfreundlichkeit temporäre Cookies ein, die für einen bestimmten festgelegten 
                    Zeitraum auf Ihrem Endgerät gespeichert werden. Besuchen Sie unsere Seite erneut, um unsere Dienste in Anspruch zu nehmen, wird automatisch erkannt, 
                    dass Sie bereits bei uns waren und welche Eingaben und Einstellungen Sie getätigt haben, um diese nicht noch einmal eingeben zu müssen.
                </p>

                <p>
                    Zum anderen setzen wir Cookies ein, um die Nutzung unserer Webseite statistisch zu erfassen und auszuwerten und unser Angebot für Sie zu optimieren. 
                    Diese Cookies ermöglichen es uns, bei einem erneuten Besuch unserer Webseite automatisch zu erkennen, dass Sie bereits bei uns waren. 
                    Diese Cookies werden nach einer jeweils definierten Zeit automatisch gelöscht.
                </p>

                <p>
                    Die durch Cookies verarbeiteten Daten sind für die genannten Zwecke zur Wahrung unserer berechtigten Interessen sowie der Dritter 
                    nach <strong>Art. 6 Abs. 1 S. 1 lit. f) DSGVO</strong> erforderlich.
                </p>

                <p>
                    Die meisten Browser akzeptieren Cookies automatisch. Wenn Sie es nicht wünschen, dass wir Informationen über Ihren Computer wiedererkennen, 
                    stellen Sie Ihren Internetbrowser bitte so ein, dass er Cookies von Ihrer Computerfestplatte löscht, alle Cookies blockiert oder Sie warnt, 
                    bevor ein Cookie gespeichert wird. Wie Sie Cookies löschen oder blockieren können, erfahren Sie im Hilfe- und Support-Bereich Ihres Internet-Browsers. 
                    Dort finden Sie Anweisungen zur Suche der Datei oder des Verzeichnisses, in dem Cookies gespeichert werden.
                </p>

                <p>
                    Bitte beachten Sie in jedem Fall, dass die vollständige Deaktivierung von Cookies dazu führen kann, dass Sie nicht alle Funktionen unserer Webseite nutzen können.
                </p>

                <p>
                    Wenn Sie über einen Link oder das Anklicken eventueller Bannerwerbung unsere Webseite verlassen und so auf fremde Seiten gelangen, kann es sein, 
                    dass auch vom Adressaten der angeklickten Zielseite Cookies gesetzt werden. Für diese Cookies sind wir rechtlich nicht verantwortlich. 
                    Zu der Benutzung solcher Cookies und der darauf gespeicherten Informationen durch unsere Werbepartner vergleichen Sie bitte deren Datenschutzerklärungen.
                </p>

                <p>
                    Bei der Bereitstellung unseres Internetangebots werden Java-Applets und JavaScript verwendet. Falls Sie sich aus Sicherheitsgründen diese Hilfsprogramme 
                    bzw. aktiven Inhalte nicht nutzbar machen wollen, sollten Sie die entsprechende Einstellung Ihres Browsers deaktivieren.
                </p>

                <p>
                    <strong>Clear-Gifs:</strong> Wir oder bestimmte Drittanbieter können eine Softwaretechnologie, sogenannte Clear-Gifs 
                    (auch bekannt als Web Beacons/Web Bugs), verwenden, die uns dabei helfen, unsere Serviceleistungen durch Messen von deren Effizienz und Leistung zu verbessern. 
                    Clear-Gifs sind winzige Grafiken mit einem eindeutigen Identifier und haben eine ähnliche Funktion wie Cookies. Im Gegensatz zu Cookies, 
                    die auf der Festplatte des Benutzercomputers gespeichert werden, sind Clear-Gifs unsichtbar in unsere Serviceleistungen eingebettet.
                </p>

                <p>
                    <strong>Flash und HTML5:</strong> Wir und bestimmte Drittanbieter können – hauptsächlich zu Werbezwecken – auch bestimmte Tracking-Technologien verwenden, 
                    die als „Flash Cookies“ und „HTML5“ bekannt sind. Einige Browser können ihre eigenen Verwaltungstools zur Entfernung oder Blockierung solcher Technologien verwenden. 
                    Weitere Informationen über den Umgang mit Flash Cookies finden Sie hier: 
                    <a href="https://www.macromedia.com/support/documentation/en/flashplayer/help/settings_manager07.html" target="_blank" rel="noopener noreferrer">
                        www.macromedia.com/support/documentation/&shy;en/flashplayer/help/settings_manager07.html
                    </a>. 
                    (Wir weisen Sie darauf hin, dass diese Webseite nicht von uns bereitgestellt wird, sodass wir deren Genauigkeit, Vollständigkeit und Verfügbarkeit nicht gewährleisten können.)
                </p>

                <p>
                    <strong>Google ReCaptcha:</strong> Wir binden die Funktion zur Erkennung von Bots, z.&nbsp;B. bei Eingaben in Onlineformularen („ReCaptcha“) des Anbieters 
                    Google LLC, 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA, ein. Datenschutzerklärung: 
                    <a href="https://www.google.com/policies/privacy/" target="_blank" rel="noopener noreferrer">www.google.com/policies/privacy/</a>, 
                    Opt-Out: 
                    <a href="https://adssettings.google.com/authenticated" target="_blank" rel="noopener noreferrer">https://adssettings.google.com/authenticated</a>.
                </p>
            </article>

            <article aria-labelledby="google-maps-apis">
                <h2 id="google-maps-apis">6. Dienste von Google Maps APIs</h2>

                <p>
                    Zur Darstellung der Routen und Ortsangaben verwenden wir auf unserer Webseite verschiedene Dienste der 
                    <a href="https://www.google.de/intl/de/about/" target="_blank" rel="noopener noreferrer">Google Inc</a> 
                    (1600 Amphitheatre Parkway, Mountain View, CA 94043, USA; im Folgenden „Google“). 
                    Dies sind im Einzelnen Google Maps, Google Maps Directions, - Distance, - Geocoding und - Geolocation.
                </p>

                <p>
                    Diese von Google bereitgestellten Dienste sind jeweils über sog. API-Schnittstellen in unsere Webseite eingebunden. 
                    Wir, als Anbieter unserer Webseite, haben keine Kenntnis, ob und ggf. welche Daten bei der Nutzung der Google Maps-Dienste an Google übertragen werden.
                </p>

                <p>
                    Für die Nutzung dieser Angebote gelten die Nutzungsbedingungen und Datenschutzbestimmungen von Google, 
                    die Sie auf der Webseite von Google einsehen können. Wir haben sie entsprechend verlinkt.
                </p>
            </article>

            <article aria-labelledby="soziale-netzwerke">
                <h2 id="soziale-netzwerke">7. Links zu unseren Internetauftritten in sozialen Netzwerken</h2>

                <p>
                    Auf unserer Webseite haben wir Links zu unseren Internetauftritten in den sozialen Netzwerken 
                    (Instagram) eingebunden. Wir weisen darauf hin, dass es sich hierbei nur um Verlinkungen handelt,
                    die zu unserem Internetauftritt in den genannten Netzwerken weiterleiten – es handelt sich nicht um sog. Plugins, 
                    mit denen Sie bspw. Informationen auf unserer Webseite in den Netzwerken „teilen“ oder „liken“ könnten.
                </p>

                <p>
                    Soweit uns bekannt ist, ist es technisch nicht möglich, dass soziale Netzwerke über die bloßen Verlinkungen 
                    personenbezogene Daten auf unserer Webseite erheben können. Zweck und Umfang der Datenerhebung nach der Weiterleitung 
                    entnehmen Sie bitte den Datenschutzinformationen des jeweiligen Netzwerkes.
                </p>
            </article>

            <article aria-labelledby="datensicherheit">
                <h2 id="datensicherheit">8. Datensicherheit</h2>

                <p>
                    Wir sind um alle notwendigen technischen und organisatorischen Sicherheitsmaßnahmen bemüht, 
                    um Ihre personenbezogenen Daten so zu speichern, dass sie weder Dritten noch der Öffentlichkeit zugänglich sind. 
                    Sollten Sie mit uns per E-Mail in Kontakt treten wollen, so weisen wir Sie darauf hin, 
                    dass bei diesem Kommunikationsweg die Vertraulichkeit der übermittelten Informationen nicht vollständig gewährleistet werden kann. 
                    Wir empfehlen Ihnen daher, uns vertrauliche Informationen ausschließlich über den Postweg zukommen zu lassen.
                </p>
            </article>

            <article aria-labelledby="aktualitaet-und-aenderung">
                <h2 id="aktualitaet-und-aenderung">9. Aktualität und Änderung dieser Datenschutzer&shy;klärung</h2>

                <p>
                    Diese Datenschutzerklärung ist aktuell gültig und hat den Stand November 2022. 
                    Durch die Weiterentwicklung unserer Webseite und Angebote darüber oder aufgrund geänderter gesetzlicher 
                    beziehungsweise behördlicher Vorgaben kann es notwendig werden, diese Datenschutzerklärung zu ändern.
                </p>

                <p>
                    Die jeweils aktuelle Datenschutzerklärung kann jederzeit auf der Webseite unter 
                    <a href="https://www.fase2.de/datenschutzerklaerung" target="_blank" rel="noopener noreferrer">
                        www.fase2.de/datenschutzerklaerung
                    </a> 
                    von Ihnen abgerufen und ausgedruckt werden.
                </p>
            </article>

            <article aria-labelledby="verantwortlicher">
                <h2 id="verantwortlicher">10. Name und Kontaktdaten des für die Verarbeitung Verantwortlichen sowie des Datenschutz&shy;beauftragten</h2>

                <p>
                    Diese Datenschutz-Information gilt für die Datenverarbeitung durch:
                </p>

                <p>
                    <strong>Verantwortlicher:</strong> Salvatore Laudani und Hüseyin Sidar, Reinoldstr. 6b, 50676 Köln<br>
                    <strong>Datenschutzbeauftragter:</strong> Salvatore Laudani und Hüseyin Sidar
                </p>
            </article>
        </div>
    </section>`,
      style: `datenschutzerklaerung-view .datenschutzerklaerung-view {
  margin: 0;
  padding: 0;
}
datenschutzerklaerung-view .datenschutzerklaerung-view .wrapper {
  max-width: 1440px;
  margin: 0 auto;
  padding: 64px 64px;
}
datenschutzerklaerung-view .datenschutzerklaerung-view .wrapper article {
  margin: 0 0 32px 0;
  padding: 0;
}
datenschutzerklaerung-view .datenschutzerklaerung-view .wrapper aside {
  margin: 0 0 32px 0;
  padding: 0;
}
@media (max-width: 992px) {
  datenschutzerklaerung-view .datenschutzerklaerung-view .wrapper {
    padding: 64px 32px;
  }
}`,
      script: `(async () => { "use strict";
return {
    data: {},
    events: [
        ['click', '.widerrufsbelehrung-view a[href^="/"]:not([target])', function (event) {
                event.preventDefault();
                if (this.buttonLink2)
                    router.navigate(this.buttonLink2);
            }],
    ]
};
 })()`
    };
  